export enum MeterManagementStatsOptions {
  Total = 1,
  SinglePhase = 2,
  ThreePhase = 3,
  InStorage = 4,
  Installed = 5,
  AverageAge = 6,
  Ratio11000_110 = 7,
  Ratio33000_110 = 8,
}
